import { RootState } from 'app/store/store';
import { roles } from 'app/shared/constants';

export const getCurrentUser = (state: RootState) => state.user.currentUser;

export const getIsUserGameMaster = (state: RootState) => {
  const currentUser = getCurrentUser(state);
  return currentUser ? currentUser.roles.includes(roles.ROLE_GAME_MASTER) : false;
};
